import React, { useEffect, useState } from 'react';

//
// <BrandLoader/> — full-screen splash that shows once per session while the
// app mounts. Renders the brand icon with three expanding pulse rings, a soft
// vertical float, and three loading dots — then fades out via CSS (see
// `.brand-loader` in index.css). Subsequent route changes within the same
// session skip the splash entirely.
//
const SESSION_KEY = 'mydrai_splash_seen';
// Total visible time: animation delay (1.25s) + fade duration (0.55s) + buffer.
const REMOVE_AFTER_MS = 2000;

export default function BrandLoader() {
  const [show, setShow] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return sessionStorage.getItem(SESSION_KEY) !== '1';
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!show) return undefined;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch { /* ignore */ }
    const t = setTimeout(() => setShow(false), REMOVE_AFTER_MS);
    return () => clearTimeout(t);
  }, [show]);

  if (!show) return null;

  return (
    <div className="brand-loader" aria-hidden="true">
      <div className="brand-loader__wordmark">
        <span className="brand-loader__halo" />
        <span className="brand-loader__halo" />
        <span className="brand-loader__halo" />
        <img src="/fullLogo.png" alt="" />
      </div>
      <div className="brand-loader__dots">
        <span /><span /><span />
      </div>
    </div>
  );
}
